import { TranslationsContext } from '@teliaee/telia-translate';
import { observer } from 'mobx-react';
import * as React from 'react';
import { Button, Grid, GridColumn, Separator, TextField } from 'telia-front-react';

import { useStores } from '../stores/RootStore';

import EmailComponent from './EmailComponent';
import { PrepaymentSteps } from './../Constants';

interface IPrepaidDataComponentProps {
  disabled: boolean;
  setStepIndex: (index: PrepaymentSteps) => void;
}

const PrepaidDataComponent = observer((props: IPrepaidDataComponentProps) => {
  const { disabled, setStepIndex } = props;
  const { priceStore, sessionStore, prepaidDataStore, mobileNumberStore, populationRegistryPersonStore: personStore } = useStores();
  const { translate } = React.useContext(TranslationsContext);

  const handleNextButtonClick = async () => {
    await prepaidDataStore.submitForm();

    if (prepaidDataStore.isStepDone) {
      setStepIndex(PrepaymentSteps.PRICE_STEP);
    }
  };

  const getMobileNumberErrorMessage = () => {
    if (!mobileNumberStore.isPrepaidInfoLoading && mobileNumberStore.numberFieldInvalid) {
      return translate(`prepaid.validation.incorrect${!mobileNumberStore.isPayable ? '.notPayable' : ''}`);
    }
    if (priceStore.noPlans) {
      return translate('prepaid.validation.no-plan');
    }
    return undefined;
  };

  const renderMobileNumberField = (): JSX.Element => {
    const numberStore = mobileNumberStore;
    return (
      <TextField
        isDisabled={disabled}
        id="prepaidPhone"
        type="tel"
        label={translate('prepaid.phonenumber')}
        prefix="+372"
        onChange={numberStore.setMobileNumber}
        errorMessage={getMobileNumberErrorMessage()}
        isInvalid={(!mobileNumberStore.isPrepaidInfoLoading && numberStore.numberFieldInvalid) || priceStore.noPlans}
      />
    );
  };

  const renderPersonalCodeField = (): JSX.Element => {
    return (
      <>
        {sessionStore.isDealer && mobileNumberStore.detaineeNumber && (
          <>
            <Separator color="invisible" spacing="xsmall" />
            <TextField
              id="personalCode"
              label={translate('prepaid.step.number.personal-code.title')}
              value={personStore.personalCode}
              isDisabled={disabled}
              onChange={personStore.updatePopulationRegistryPerson}
              errorMessage={personStore.personalCodeFieldErrorMessage(translate('prepaid.validation.incorrect'))}
              isInvalid={personStore.personalCodeFieldInvalid}
            />
          </>
        )}
      </>
    );
  };

  const renderNameField = (): JSX.Element => {
    return (
      <>
        {sessionStore.isDealer && mobileNumberStore.detaineeNumber && (
          <>
            <Separator color="invisible" spacing="xxsmall" />
            <TextField
              id="personName"
              label={translate('prepaid.step.number.person-name.title')}
              value={personStore.personName}
              isDisabled={true}
              errorMessage={personStore.personNameFieldErrorMessage(translate('prepaid.validation.name-error'))}
              helpMessage={personStore.personNameFieldHelpMessage(translate('prepaid.validation.waiting-for-name'))}
            />
          </>
        )}
      </>
    );
  };

  const renderForwardButton = (): JSX.Element => {
    return (
      <Grid>
        <GridColumn align={['middle-xs']} className="text-right">
          <Button size="small" iconRight="#arrow-right" text={translate('prepaid.steps.next')} disabled={disabled} onClick={handleNextButtonClick} />
        </GridColumn>
      </Grid>
    );
  };

  return (
    <>
      {renderMobileNumberField()}
      {renderPersonalCodeField()}
      {renderNameField()}
      {prepaidDataStore.showEmailComponent && <EmailComponent disabled={disabled} />}
      <Separator color="invisible" spacing="xxsmall" />
      {renderForwardButton()}
    </>
  );
});
export default PrepaidDataComponent;
